import { Divider } from "antd";

const FilterComponent = ({ initialFilterValues, initialFilterOutValues }) => {
	const renderFilterValues = (filterValues) => {
		return Object.keys(filterValues).map((key) => {
			return (
				<div key={key} style={{ marginBottom: "10px", fontSize: "13px" }}>
					<span>{key}: </span>
					<span>
						{Array.isArray(filterValues[key])
							? filterValues[key].length
								? filterValues[key].join(", ")
								: "ALL"
							: filterValues[key] || "None"}
					</span>
				</div>
			);
		});
	};

	return (
		<div style={{ paddingInline: "20px" }}>
			<p className="pl-10 m-5 font-bold">Filter Values</p>
			{renderFilterValues(initialFilterValues)}

			<Divider />

			<p className="pl-10 m-5 font-bold">Filter Out Values</p>
			{renderFilterValues(initialFilterOutValues)}
		</div>
	);
};

const DisplayFilterData = ({ initialFilterValues, initialFilterOutValues }) => {
	return (
		<div className={'html2pdf__page-break'}>
			<FilterComponent
				initialFilterValues={initialFilterValues}
				initialFilterOutValues={initialFilterOutValues}
			/>
		</div>
	);
};

export default DisplayFilterData;
